(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["last-minute"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(n) {
      return '$' + (Math.round(n * 100) % 100 === 0 ? String(Math.round(n)) : n.toFixed(2));
    }

    function init(root) {
      if (!root || root.lmReady) return;
      root.lmReady = true;

      /* Subline: swap to the later copy once the switch time passes (covers cached pages). */
      var sub = root.querySelector('[data-lm-sub-at]');
      if (sub) {
        var subAt = Number(sub.getAttribute('data-lm-sub-at')) * 1000;
        var subSwap = function () { sub.textContent = sub.getAttribute('data-lm-sub-late'); };
        var subWait = subAt - Date.now();
        if (subWait <= 0) subSwap();
        else if (subWait < 86400000) setTimeout(subSwap, subWait);
      }

      /* Promise underline: wait until it is on screen, then draw once. */
      var line = root.querySelector('[data-lm-line]');
      var lineSeen = null;
      function drawLine() {
        line.classList.remove('is-waiting', 'is-drawing');
        void line.offsetWidth;
        line.classList.add('is-drawing');
      }
      if (line && 'IntersectionObserver' in window) {
        line.classList.add('is-waiting');
        lineSeen = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting) {
              lineSeen.disconnect();
              drawLine();
            }
          },
          { threshold: 1 }
        );
        lineSeen.observe(line);
      }
      root.lmDestroy = function () {
        if (lineSeen) lineSeen.disconnect();
      };

      /* iOS only shows :active on tap when a touch listener exists. */
      root.addEventListener('touchstart', function () {}, { passive: true });

      var screens = {
        landing: root.querySelector('[data-lm-screen="landing"]'),
        pick: root.querySelector('[data-lm-screen="pick"]'),
      };
      /* Closed or sold out: there is no second screen, so nothing else to wire. */
      if (!screens.landing || !screens.pick) return;

      var DELIVERY = Number(root.getAttribute('data-lm-delivery')) || 0;
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-lm-row]'));
      var avail = rows.map(function (row) {
        return row.getAttribute('data-lm-available') !== 'false';
      });
      var title = root.querySelector('[data-lm-title]');
      var hint = root.querySelector('[data-lm-hint]');
      var msg = root.querySelector('[data-lm-msg]');
      var where = root.querySelector('[data-lm-where]');
      var checkout = root.querySelector('[data-lm-checkout]');
      /* Backup link says Apple Pay only where Apple Pay can actually be used. */
      var cardLabel = checkout.getAttribute('data-lm-card-label');
      if (cardLabel) {
        var applePay = false;
        try {
          applePay = !!(window.ApplePaySession && window.ApplePaySession.canMakePayments());
        } catch (err) {
          applePay = false;
        }
        if (!applePay) checkout.textContent = cardLabel;
      }
      var checkoutLabel = checkout.textContent;
      var totalEl = root.querySelector('[data-lm-total]');
      var state = { size: 2, price: 0, qty: [], busy: false, sending: false, fails: 0 };

      /* Run a one-shot CSS animation class, then call done. If motion is off
         (OS setting) the class resolves to no animation and done runs straight
         away, so nothing ever waits on motion. */
      function play(el, cls, done) {
        el.classList.remove(cls);
        void el.offsetWidth;
        el.classList.add(cls);
        if (getComputedStyle(el).animationName === 'none') {
          el.classList.remove(cls);
          if (done) done();
          return;
        }
        el.addEventListener('animationend', function end(e) {
          if (e.target !== el) return;
          el.removeEventListener('animationend', end);
          el.classList.remove(cls);
          if (done) done();
        });
      }

      /* The theme scrolls .page-wrapper on desktop and the window on phones;
         scrollIntoView covers both. */
      function toTop() {
        if (root.getBoundingClientRect().top >= 0) return;
        try {
          root.scrollIntoView({ block: 'start', behavior: 'instant' });
        } catch (err) {
          root.scrollIntoView(true);
        }
      }

      function go(to, dir, after) {
        if (state.busy) return;
        var from = to === 'pick' ? screens.landing : screens.pick;
        var next = screens[to];
        state.busy = true;
        root.setAttribute('data-dir', dir);
        play(from, 'is-leaving', function () {
          from.hidden = true;
          next.hidden = false;
          toTop();
          if (after) after();
          play(next, 'is-entering', function () {
            state.busy = false;
          });
        });
      }

      function left() {
        return (
          state.size -
          state.qty.reduce(function (sum, n) {
            return sum + n;
          }, 0)
        );
      }

      /* Default split: 1/0, 1/1, 2/1. A sold out colour gets none and the other takes the lot. */
      function split(size) {
        var qty = rows.map(function () {
          return 0;
        });
        var open = [];
        avail.forEach(function (ok, i) {
          if (ok) open.push(i);
        });
        if (open.length === 1) {
          qty[open[0]] = size;
        } else if (open.length > 1) {
          qty[open[0]] = Math.ceil(size / 2);
          qty[open[1]] = Math.floor(size / 2);
        }
        return qty;
      }
      state.qty = split(state.size);

      /* Messages sit under the field they are about; with no field they sit under the location box. */
      var msgHome = msg.parentNode;
      function say(text, field) {
        var anchor = field ? field.closest('.lm-pair-row') || field : null;
        if (text && anchor) {
          anchor.insertAdjacentElement('afterend', msg);
          msg.classList.add('is-flow');
        } else {
          msgHome.appendChild(msg);
          msg.classList.remove('is-flow');
        }
        msg.textContent = text;
        msg.classList.toggle('is-on', text !== '');
      }

      function render(wasReady) {
        var remaining = left();
        var ready = remaining === 0;
        rows.forEach(function (row, i) {
          row.querySelector('[data-lm-num]').textContent = state.qty[i];
          row.querySelector('[data-lm-step="-1"]').setAttribute('aria-disabled', String(state.qty[i] === 0));
          row.querySelector('[data-lm-step="1"]').setAttribute('aria-disabled', String(ready || !avail[i]));
        });
        hint.textContent = ready ? '' : 'Pick ' + remaining + ' more.';
        hint.classList.toggle('is-on', !ready);
        var main = root.querySelector('[data-lm-venmo]') || checkout;
        main.classList.toggle('is-ready', ready);
        main.setAttribute('aria-disabled', String(!ready));
        checkout.setAttribute('aria-disabled', String(!ready));
        if (ready && wasReady === false) play(main, 'is-waking');
      }

      function openBundle(btn) {
        var size = Number(btn.getAttribute('data-lm-bundle'));
        var price = Number(btn.getAttribute('data-lm-price'));
        var word = size === 1 ? ' hat' : ' hats';
        btn.classList.add('is-picked');
        go('pick', 'forward', function () {
          btn.classList.remove('is-picked');
          state.size = size;
          state.price = price;
          state.qty = split(size);
          title.textContent = 'Pick your ' + size + word;
          root.querySelector('[data-lm-sum-label]').textContent = size + word;
          root.querySelector('[data-lm-sum-hats]').textContent = money(price);
          totalEl.textContent = money(price + DELIVERY);
          say('');
          render();
          play(totalEl, 'is-settling');
          title.focus({ preventScroll: true });
        });
      }

      function post(url, body) {
        return fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then(function (res) {
          if (!res.ok) throw new Error(url + ' ' + res.status);
          return res.json();
        });
      }

      function idle() {
        state.sending = false;
        checkout.disabled = false;
        checkout.textContent = checkoutLabel;
      }
      root.lmIdle = idle;

      /* Card path: carry whatever the buyer already typed into Shopify's checkout address form. */
      function prefill() {
        var get = function (sel) {
          var el = root.querySelector(sel);
          return el ? el.value.trim() : '';
        };
        var street = get('[data-lm-addr]');
        var zipCode = get('[data-lm-zip]');
        var fields = {
          address1: street,
          address2: get('[data-lm-unit]'),
          zip: zipCode,
          phone: get('[data-lm-phone]'),
        };
        if (street || zipCode) {
          fields.city = 'San Francisco';
          fields.province = 'CA';
          fields.country = 'US';
        }
        var parts = [];
        Object.keys(fields).forEach(function (key) {
          if (fields[key]) parts.push('checkout[shipping_address][' + key + ']=' + encodeURIComponent(fields[key]));
        });
        return parts.length ? '?' + parts.join('&') : '';
      }

      /* Checkout: empty the cart, add this bundle, attach the location, go pay. */
      function submit() {
        if (state.sending || state.busy || left() !== 0) return;
        var place = where.value.trim();
        if (!place && !root.querySelector('[data-lm-addr]')) {
          say('Tell us where to find you.');
          where.focus();
          return;
        }
        var items = [];
        rows.forEach(function (row, i) {
          if (state.qty[i] > 0) items.push({ id: Number(row.getAttribute('data-lm-variant')), quantity: state.qty[i] });
        });
        if (!items.length) return;

        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var bundle = state.size + (state.size === 1 ? ' hat' : ' hats');
        var update = { attributes: { Bundle: bundle } };
        if (place) update.note = 'Where: ' + place;

        state.sending = true;
        checkout.disabled = true;
        checkout.textContent = 'One sec...';
        say('');

        /* With an address typed in, Shopify's cart link is the route that carries it into checkout. */
        var filled = prefill();
        if (filled) {
          window.location =
            base +
            'cart/' +
            items
              .map(function (item) {
                return item.id + ':' + item.quantity;
              })
              .join(',') +
            filled +
            (update.note ? '&note=' + encodeURIComponent(update.note) : '') +
            '&attributes[Bundle]=' +
            encodeURIComponent(bundle);
          return;
        }

        post(base + 'cart/clear.js', {})
          .then(function () {
            return post(base + 'cart/add.js', { items: items });
          })
          .then(function () {
            return post(base + 'cart/update.js', update);
          })
          .then(function () {
            window.location = base + 'checkout';
          })
          .catch(function () {
            state.fails += 1;
            if (state.fails > 1) {
              /* Last resort: Shopify's cart permalink builds the same cart and goes to checkout. */
              var link =
                base +
                'cart/' +
                items
                  .map(function (item) {
                    return item.id + ':' + item.quantity;
                  })
                  .join(',') +
                '?note=' +
                encodeURIComponent(update.note || '') +
                '&attributes[Bundle]=' +
                encodeURIComponent(bundle);
              window.location = link;
              return;
            }
            idle();
            say('Something went wrong. Try again.');
          });
      }

      /* Venmo: same checks, then open Venmo with the amount and a private note filled in. */
      function venmo(btn) {
        if (state.sending || state.busy || left() !== 0) return;
        var place = where.value.trim();
        var addr = root.querySelector('[data-lm-addr]');
        var unit = root.querySelector('[data-lm-unit]');
        var street = addr ? addr.value.trim() : '';
        if (addr && street.length < 4) {
          say('Add your street address.', addr);
          addr.focus();
          return;
        }
        if (!addr && !place) {
          say('Tell us where to find you.');
          where.focus();
          return;
        }
        /* Zip: the allowed list is read from the zip codes line, so there is one place to edit it. */
        var zip = root.querySelector('[data-lm-zip]');
        var zipValue = zip ? zip.value.trim() : '';
        if (zip) {
          var allowed = zip.getAttribute('data-lm-zips').match(/\b\d{5}\b/g) || [];
          if (!/^\d{5}$/.test(zipValue)) {
            say('Add your 5 digit zip code.', zip);
            zip.focus();
            return;
          }
          if (allowed.length && allowed.indexOf(zipValue) === -1) {
            say("Sorry, we don't deliver to " + zipValue + '.', zip);
            zip.focus();
            return;
          }
        }
        var phone = root.querySelector('[data-lm-phone]');
        var digits = phone ? phone.value.replace(/\D/g, '') : '';
        if (phone && digits.length < 10) {
          say('Add a phone number so we can text you.', phone);
          phone.focus();
          return;
        }
        var picks = [];
        rows.forEach(function (row, i) {
          if (state.qty[i] > 0) picks.push(state.qty[i] + ' ' + row.querySelector('.lm-row__name').textContent.trim());
        });
        if (!picks.length) return;
        var total = Number(root.querySelector('[data-lm-total]').textContent.replace(/[^0-9.]/g, ''));
        var to = [street, unit ? unit.value.trim() : '', zipValue].filter(Boolean).join(', ');
        var cell = digits.length === 10 ? digits.slice(0, 3) + '-' + digits.slice(3, 6) + '-' + digits.slice(6) : phone ? phone.value.trim() : '';
        /* One labelled line per fact, so the note reads the same way every time. */
        var lines = ['HATS: ' + picks.join(', ')];
        if (to) lines.push('ADDRESS: ' + to);
        if (cell) lines.push('CELL: ' + cell);
        if (place) lines.push('NOTE: ' + place);
        var note = lines.join('\n').slice(0, 280);
        var query =
          'txn=pay&audience=private&recipients=' +
          encodeURIComponent(btn.getAttribute('data-lm-venmo')) +
          '&amount=' +
          encodeURIComponent(total.toFixed(2)) +
          '&note=' +
          encodeURIComponent(note);
        var web = 'https://venmo.com/?' + query;
        say('');
        /* Phones: open the app directly, which keeps spaces and line breaks in the note intact.
           If the app does not take over, fall back to the web link. */
        if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
          var fallback = setTimeout(function () {
            if (!document.hidden) window.location = web;
          }, 1500);
          document.addEventListener(
            'visibilitychange',
            function () {
              if (document.hidden) clearTimeout(fallback);
            },
            { once: true }
          );
          window.location = 'venmo://paycharge?' + query;
          return;
        }
        window.location = web;
      }

      root.addEventListener('input', function (e) {
        if (e.target.closest('[data-lm-zip], [data-lm-phone], [data-lm-addr]') && msg.textContent) say('');
      });

      where.addEventListener('input', function () {
        if (msg.textContent) say('');
      });

      root.addEventListener('click', function (e) {
        var bundle = e.target.closest('[data-lm-bundle]');
        if (bundle) return openBundle(bundle);

        if (e.target.closest('[data-lm-back]')) {
          if (state.sending) return;
          return go('landing', 'back');
        }

        var step = e.target.closest('[data-lm-step]');
        if (step) {
          if (state.sending) return;
          var i = rows.indexOf(step.closest('[data-lm-row]'));
          var delta = Number(step.getAttribute('data-lm-step'));
          var num = rows[i].querySelector('[data-lm-num]');
          var blocked = delta > 0 ? left() === 0 || !avail[i] : state.qty[i] === 0;
          if (blocked) return play(num, 'is-nope');
          var wasReady = left() === 0;
          state.qty[i] += delta;
          render(wasReady);
          num.classList.remove('is-nope');
          play(num, delta > 0 ? 'is-tick-up' : 'is-tick-down');
          return;
        }

        var pay = e.target.closest('[data-lm-venmo]');
        if (pay) return venmo(pay);

        if (e.target.closest('[data-lm-checkout]')) submit();
      });
    }

    function each(scope, fn) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-lm]'), fn);
    }

    each(document, init);

    /* Theme editor: the section's markup is replaced on every setting change. */
    document.addEventListener('shopify:section:load', function (e) {
      each(e.target, init);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      each(e.target, function (root) {
        if (root.lmDestroy) root.lmDestroy();
      });
    });

    /* Coming back from checkout with the page restored from cache: wake the button up again. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      each(document, function (root) {
        if (root.lmIdle) root.lmIdle();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
